import { Box } from '@factorialco/deprecated-design-system'
import { StatusTag } from '@factorialco/factorial-one-react/dist/experimental'

interface Props {
  label: string
  ratingValue: string
  locked?: boolean
}
const RatingTag = ({ label, ratingValue }: Props) => {
  const getRatingLabelColor = () => {
    switch (ratingValue) {
      case '5':
        return 'positive'
      case '4':
        return 'positive'
      case '3':
        return 'warning'
      case '2':
        return 'critical'
      case '1':
        return 'critical'
      default:
        return 'neutral'
    }
  }
  return (
    <Box width="fit-content">
      <StatusTag text={`${label}: ${ratingValue}`} variant={getRatingLabelColor()} />
    </Box>
  )
}

export default RatingTag
